/* eslint-disable func-names */
import forEach from '../../../../javascripts/dom/forEach';

const stages = document.querySelectorAll('[data-js-module="o-stage"]');
const slidesSelector = '[data-js-element="o-stage__slides"]';

export default function init() {
  const initStage = async () => {
    const { tns } = await import(
      /* webpackChunkName: "tiny-slider" */ '../../../../../node_modules/tiny-slider/src/tiny-slider'
    );

    const slidesContainer = document.querySelector(slidesSelector);
    if (slidesContainer) {
      // eslint-disable-next-line no-unused-vars
      const slider = tns({
        container: slidesContainer,
        arrowKeys: true,
        mouseDrag: true,
        touch: true,
        mode: 'gallery',
        autoHeight: true,
        loop: true,
        nav: false,
        autoplay: true,
        autoplayTimeout: 10000,
        autoplayHoverPause: true,
        autoplayButton: false,
        autoplayButtonOutput: false,
        swipeAngle: false,
        controls: false,
        speed: 2000,
        animateIn: 'o-gallery__fade-in',
        animateOut: 'o-gallery__fade-out',
        animateNormal: 'o-gallery__fade-normal'
      });
    }
  };

  if (stages.length) initStage();
}

if (stages.length) init();
